import React from 'react';
import {
    Modal,
    Box,
    Typography,
    FormControlLabel,
    Checkbox,
} from '@mui/material';

const AgreementModal = ({
    open,
    onClose,
    title,
    description,
    pdfUrl,
    checked = false,
    onToggle,
    acceptLabel,
    noticeText = 'Click margins to close after accepting',
}) => {
    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    const handleClickToClose = () => onClose();

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="agreement-modal-title"
            aria-describedby="agreement-modal-description"
            sx={{ zIndex: 1400 }}
            slotProps={{
                backdrop: {
                    sx: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
                },
            }}
        >
            <Box
                onClick={handleBackdropClick}
                sx={{
                    outline: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    backgroundColor: '#404040',
                }}
            >
                <Box
                    sx={{
                        marginBottom: '5%',
                        paddingTop: '1rem',
                        padding: '1rem',
                        textAlign: 'center',
                        maxWidth: '90%',
                        backgroundColor: 'transparent',
                        color: 'white',
                        border: '1px solid rgba(255, 255, 255, 0.4)',
                        borderRadius: 1,
                    }}
                >
                    <Typography
                        id="agreement-modal-title"
                        variant="h3"
                        component="h3"
                        onClick={handleClickToClose}
                        sx={{ cursor: 'pointer' }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        id="agreement-modal-description"
                        component="p"
                        onClick={handleClickToClose}
                        sx={{ cursor: 'pointer' }}
                    >
                        {description}
                    </Typography>
                    <Box sx={{ width: '100%', height: '75vh', margin: 'auto' }}>
                        <iframe
                            src={pdfUrl}
                            title={title}
                            style={{ width: '100%', height: '100%', border: 0 }}
                        />
                    </Box>
                    <Box sx={{ margin: '1%' }}>
                        <FormControlLabel
                            sx={{ color: 'white' }}
                            control={
                                <Checkbox
                                    checked={checked}
                                    onChange={(event) => onToggle(event.target.checked)}
                                    sx={{ color: 'white', '&.Mui-checked': { color: 'white' } }}
                                />
                            }
                            label={acceptLabel}
                        />
                    </Box>
                    {noticeText && (
                        <Typography
                            onClick={handleClickToClose}
                            sx={{
                                color: 'white',
                                textDecoration: 'underline',
                                fontStyle: 'italic',
                                cursor: 'pointer',
                            }}
                        >
                            {noticeText}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Modal>
    );
};

export default AgreementModal;
